var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumberOfInstallments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 101,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.055 101c1.96-32.06 5.04-51.94 16.8-81.9h-21V3h40.74v14c-13.72 32.2-16.8 51.52-18.9 84H5.055zm37.502-27.3c0-12.46 5.46-18.9 15.82-30.94 5.88-6.86 9.52-11.2 9.52-17.08v-5.46c0-2.1-1.26-3.22-3.08-3.22h-.28c-1.82 0-3.08 1.26-3.08 3.22V34.5h-18.62V22.32c0-14.56 8.4-21.42 21.56-21.42h.84c13.3 0 21.7 7 21.7 21.42v1.54c0 13.86-5.46 19.88-15.96 31.36-6.16 6.72-9.52 10.5-9.52 17.08v12.6h6.72V63.2h18.9V101h-44.52V73.7zM118.49 101l-3.92-33.88-.84-10.5h-.28l-.84 10.5-3.92 33.88h-19.74l9.1-53.06L88.95 3h19.74l3.92 27.02.84 11.2h.28l.7-11.2L118.489 3h19.74l-9.1 44.66 9.1 53.34h-19.74z",
    fill: "#FFCA00"
  })));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/number-of-installments-0211d65d623bd45625c8269f4b404470.svg";
export { SvgNumberOfInstallments as ReactComponent };